import _ from 'underscore';
import { Scenario } from 'views/bluviu-nutrition/features/scenarios/types/scenario.type';
import { ScenarioState } from '../../../types/scenario-state.enum';

const isScenarioDisabled = (scenario: Scenario, isLoading: boolean, isFree: boolean = false): boolean => {
  if (isLoading) return true;
  if (!isFree && _.isNull(scenario.globalSiteId)) return true;

  switch (scenario.state) {
    case ScenarioState.CREATED:
    case ScenarioState.FAILED:
      return false;

    case ScenarioState.COMPLETED:
    case ScenarioState.SUBMITTED:
    case ScenarioState.SCENARIO_RESULT_SENT:
      return true;

    default:
      return true;
  }
};

export default isScenarioDisabled;
